import { canEnableSwiperLoop } from './utils';

export default (opts = {}) => ({
    swiper: null,
    analytics: {
        label: opts.label || null,
        currency: opts.currency || null,
        listId: opts.listId || 'products_carousel',
    },
    init() {
        this.enable();
    },
    enable() {
        const breakpoints = {
            320: {
                slidesPerView: 1.25,
                pagination: false,
                spaceBetween: 9.375,
            },
            768: {
                slidesPerView: 3.25,
                pagination: false,
            },
            1440: {
                slidesPerView: 4.25,
                pagination: false,
                spaceBetween: 5.625,
            },
            1680: {
                slidesPerView: 5.25,
                pagination: false,
            },
        };

        this.swiper = new Swiper(this.$refs.productsCarousel, {
            slidesPerView: 1.5,
            spaceBetween: 12,
            direction: 'horizontal',
            loop: canEnableSwiperLoop(this.$refs.productsCarousel, { slidesPerView: 1.5, breakpoints }),
            navigation: {
                nextEl: this.$refs.next,
                prevEl: this.$refs.previous,
            },
            breakpoints,
            autoplay: {
                delay: 333000,
                disableOnInteraction: false,
            },
            // keyboard control
            keyboard: {
                enabled: true,
            },
        });

        this.$refs.next.addEventListener('click', function() {
            this.swiper.slideNext();
        });
        this.$refs.previous.addEventListener('click', function() {
            this.swiper.slidePrev();
        });
    },
    onItemClick(event) {
        const link = event.target.closest('.swiper-slide a');
        if (!link) return;
        const slide = event.target.closest('.swiper-slide');
        if (!slide) return;

        const item = {
            item_id: slide.dataset.itemId,
            item_name: slide.dataset.itemName,
        };

        const payload = {
            event: 'view_item_list',
            currency: this.analytics.currency,
            item_list_id: this.analytics.listId,
            item_list_name: this.analytics.label,
            items: [item],
        };

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(payload);
    },
});
